import '../scss/main.scss';
import * as $ from 'jquery';
import datepicker from 'js-datepicker'
require("fslightbox");
import { insertArrowsToButtons } from './components/button'
import { allChildrenEqualWidth } from './functions/allChildrenEqualWidth'
import { navbarScrollListen } from './functions/navbarScrollListen'
import { animateSubMenuReveal } from './components/animateSubMenuReveal'
import { insertElementsToNavbar } from './components/insertElementsToNavbar'
import { createMobileNav } from './components/createMobileNav'
import { insertSearch } from './components/insertSearch'
import { insertStrefaKlienta } from './components/insertStrefaKlienta'
import { activateHamburger } from './components/activateHamburger'
import { swiperInit } from './components/swiper'
import { detectIfSelectShow } from './components/detectIfSelectShow'
import { preloader } from './components/preloader'
import { copyBankAccountNumber } from './components/copyBankAccountNumber'
import { lazyloadInit } from './components/lazyloadInit'


preloader();
insertArrowsToButtons();
allChildrenEqualWidth();
navbarScrollListen();
animateSubMenuReveal();
createMobileNav(insertSearch, insertStrefaKlienta);
insertElementsToNavbar(insertSearch, insertStrefaKlienta);
activateHamburger();
swiperInit();
detectIfSelectShow();
copyBankAccountNumber();
lazyloadInit();


// date picker
let calendar = document.querySelector(".calendar-from");
if (calendar) {
    const pickerFrom = datepicker('.calendar-from', {
        formatter: (input, date, instance) => {
            const value = date.toLocaleDateString()
            input.value = value // => '1/1/2099'
        },
        customMonths: [
            'Styczeń',   // January
            'Luty',      // February
            'Marzec',    // March
            'Kwiecień',  // April
            'Maj',       // May
            'Czerwiec',  // June
            'Lipiec',    // July
            'Sierpień',  // August
            'Wrzesień',  // September
            'Październik', // October
            'Listopad',  // November
            'Grudzień'   // December
        ],
        customDays: ['pon', 'wt', 'śr', 'czw', 'pt', 'sb', 'nd']
    });
    const pickerTo = datepicker('.calendar-to', {
        formatter: (input, date, instance) => {
            const value = date.toLocaleDateString()
            input.value = value // => '1/1/2099'
        },
        customMonths: [
            'Styczeń',   // January
            'Luty',      // February
            'Marzec',    // March
            'Kwiecień',  // April
            'Maj',       // May
            'Czerwiec',  // June
            'Lipiec',    // July
            'Sierpień',  // August
            'Wrzesień',  // September
            'Październik', // October
            'Listopad',  // November
            'Grudzień'   // December
        ],
        customDays: ['pon', 'wt', 'śr', 'czw', 'pt', 'sb', 'nd']
    });
}


// fsLightbox.open();